// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"ArrowBack__pc_only___1erLx","sp_only":"ArrowBack__sp_only___LneCj","arrow_back":"ArrowBack__arrow_back___2Vd42"};